module.exports = __webpack_public_path__ + "img/404_page_notfound_frontend_bangunan.6c931d1d.svg";